// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ITemplateVariableDto
 */
export interface ITemplateVariableDto {
    /**
     * 
     * @type {string}
     * @memberof ITemplateVariableDto
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ITemplateVariableDto
     */
    value?: string;
}

/**
 * Check if a given object implements the ITemplateVariableDto interface.
 */
export function instanceOfITemplateVariableDto(value: object): value is ITemplateVariableDto {
    return true;
}

export function ITemplateVariableDtoFromJSON(json: any): ITemplateVariableDto {
    return ITemplateVariableDtoFromJSONTyped(json, false);
}

export function ITemplateVariableDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITemplateVariableDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function ITemplateVariableDtoToJSON(json: any): ITemplateVariableDto {
    return ITemplateVariableDtoToJSONTyped(json, false);
}

export function ITemplateVariableDtoToJSONTyped(value?: ITemplateVariableDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'value': value['value'],
    };
}

